/**
 * Detects if the app is running inside an iframe.
 * Uses window.self !== window.top comparison.
 * Returns true if cross-origin (access to window.top throws error).
 */
export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

/**
 * Cached result - computed once since it never changes during session
 */
export const IN_IFRAME = isInIframe();
